import { NgModule, Type } from '@angular/core';
import { CategoryBillablePipe } from './category-table-pipes/categoryBillable.pipe';
import { CategoryBillableFinalPipe } from './category-table-pipes/categoryBillableFinal.pipe';
import { CategoryCostPipe } from './category-table-pipes/categoryCost.pipe';
import { CategoryExpenseBillablePipe } from './category-table-pipes/categoryExpenseBillable.pipe';
import { CategoryExpenseBillableFinalPipe } from './category-table-pipes/categoryExpenseBillableFinal.pipe';
import { CategoryExpenseCostPipe } from './category-table-pipes/categoryExpenseCost.pipe';
import { CategoryHoursPipe } from './category-table-pipes/categoryHours.pipe';
import { CategoryTotalHoursPipe } from './category-table-pipes/categoryTotalHours.pipe';
import { CategoryCodePipe } from './common/categoryCode.pipe';
import { ClassDescriptionPipe } from './common/classDescription.pipe';
import { ClearValuePipe } from './common/clear-value.pipe';
import { DateFormatPipe } from './common/date-format.pipe';
import { EnumLabelPipe } from './common/enum-label.pipe';
import { IsModuleIncludedInLicensePipe } from './common/Is-module-included-in-license.pipe';
import { IsUserLicensedInModulePipe } from './common/is-user-licensed-in-module.pipe';
import { NodeTotalPercentagePipe } from './common/node-percentage.pipe';
import { IsUserInRolePipe } from './common/user-role.pipe';
import { ClassHoursPipe } from './department-table-pipes/classHours.pipe';
import { DepartmentHoursPipe } from './department-table-pipes/departmentHours.pipe';
import { ExpenseBillablePipe } from './department-table-pipes/expenseBillable.pipe';
import { ExpenseBillableFinalPipe } from './department-table-pipes/expenseBillableFinal.pipe';
import { ExpenseCostPipe } from './department-table-pipes/expenseCost.pipe';
import { HoursBillablePipe } from './department-table-pipes/hoursBillable.pipe';
import { HoursBillableFinalPipe } from './department-table-pipes/hoursBillableFinal.pipe';
import { HoursCostPipe } from './department-table-pipes/hoursCost.pipe';
import { InternalFeeBillableFinalPipe } from './department-table-pipes/internal-fee-billable-final.pipe';
import { InternalFeeBillablePipe } from './department-table-pipes/internal-fee-billable.pipe';
import { InternalFeeCostPipe } from './department-table-pipes/internal-fee-cost.pipe';
import { InternalFeeQuantityPipe } from './department-table-pipes/internal-fee-quantity.pipe';

const exportAndDeclare: Type<unknown>[] = [
  DateFormatPipe,
  EnumLabelPipe,
  ClearValuePipe,
  CategoryCodePipe,
  ClassDescriptionPipe,
  ClassHoursPipe,
  DepartmentHoursPipe,
  HoursCostPipe,
  HoursBillablePipe,
  HoursBillableFinalPipe,
  ExpenseCostPipe,
  ExpenseBillablePipe,
  ExpenseBillableFinalPipe,
  CategoryHoursPipe,
  CategoryTotalHoursPipe,
  CategoryCostPipe,
  CategoryBillablePipe,
  CategoryExpenseCostPipe,
  CategoryExpenseBillablePipe,
  CategoryBillableFinalPipe,
  CategoryExpenseBillableFinalPipe,
  IsUserInRolePipe,
  IsUserLicensedInModulePipe,
  IsModuleIncludedInLicensePipe,
  NodeTotalPercentagePipe,
  InternalFeeCostPipe,
  InternalFeeBillablePipe,
  InternalFeeBillableFinalPipe,
  InternalFeeQuantityPipe
];

@NgModule({
  exports: exportAndDeclare,
  declarations: exportAndDeclare
})
export class PipesModule {}
